import clsx from "clsx";

type Props = {
  align?: "top" | "bottom";
};

export const TimelineDot = ({ align = "top" }: Props) => {
  return (
    <div
      className={clsx(
        "absolute left-0 size-2.5 rounded-full border-2 border-white bg-text-primary",
        {
          "top-0 -translate-x-1/2 -translate-y-1/2": align === "top",
          "bottom-0 -translate-x-1/2 translate-y-1/2": align === "bottom",
        },
      )}
    />
  );
};
